import Vue from 'vue'
import store from '@/store'
import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import { i18nRender } from '@/locales'
import {
  ACCESS_TOKEN
  // LANGUAGE
} from '@/store/mutation-types'
// 创建 axios 实例
const baseURL = location.host === 'localhost:8090' ? '/downloadcenter' : process.env.VUE_APP_UNIVERSAL_API
const service = axios.create({
  // baseURL: baseURL + '/v1',
  baseURL,
  timeout: 60000 // 请求超时时间
})

const handleError = (error) => {
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use((config) => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  // const lang = Vue.ls.get(LANGUAGE) || 'zh_CN'

  if (token) {
    config.headers['Authorization'] = `${token}` // 让每个请求携带自定义 token 请根据实际情况自行修改
    store.getters.localDefaultConfig?.systemLeave && store.dispatch('SetLocalDefaultConfig', {
      systemLeave: false
    })
  }
  return config
}, handleError)

// response interceptor
service.interceptors.response.use((response) => {
  if (`${response?.data?.code}` === '200' || `${response?.data?.code}` === '0') {
    const { authorization } = response.headers
    if (authorization) {
      Vue.ls.set(ACCESS_TOKEN, authorization)
    }
    return response.data
  } else if (response.data.code === 'saas.sso.subject.service.info.error.code.0015') {
    notification.open({
      prefixCls: 'home-ant-notification',
      message: '异常提醒',
      description: response.data.message,
      type: 'warning',
      btn: h => (
        <a-button type="primary" prefixCls="home-ant-btn" size="small" on={ { click: () => (window.location.href = '/') } }>返回首页</a-button>
      ),
      closeIcon: h => <span style="display:none"></span>
    })
  } else {
    const key = response.data ? response.data.code : ''
    notification.warning({
      prefixCls: 'home-ant-notification',
      key: key,
      message: i18nRender('notification-modal.title.prompt'),
      description: (response.data && response.data.message) || '请求出现错误，请稍后再试'
    })
    return Promise.reject(response.data)
  }
}, handleError)

export {
  service as axios
}
